import Chip, { ChipProps } from "@mui/material/Chip";

export type { ChipProps };

export default Chip;
